"use strict";
/*
 * Created on 02 20 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");

var ValueWithUnit_1 = require("../../core/model/ValueWithUnit");

var SelloutType_1 = require("./SelloutType");
/**
 * <p>
 * The source data of this domain object are readonly and they are typically imported from external system. The core usage of this
 * data is for sellout management. Data includes the key information about which product is intended for sellout of particular type at
 * particular site.
 * </p>
 *
 * <p>
 * <b>Originally, there could be only one sellout type on product/site combination at one time, but now, system supports multiple sellout
 * types on product/site tuple. We call a combination of product/site/type as product/site/type triplet, or just a Triplet in context of
 * sellouts.</b> Even within storage can be only one product/site/type combination (unique index is used on product/site/type combination).
 * </p>
 *
 * <ul>
 *     <li>
 *         If a product/site/type (a Triplet) was identified for sellout of particular type at the past and it is not among sellout supply
 *         of that type now, it means that a Triplet is not determined for sellout of that type anymore and existing sellout release on the
 *         Triplet (if any) should be ended.
 *     </li>
 *     <li>
 *         This implies, that if a tuple of product/site does not exist at all within data, product site tuple should not be part of any
 *         sellout at all.
 *     </li>
 * </ul>
 *
 * @author JMe
 */


var SelloutSupply =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(SelloutSupply, _StateDomainObject_1$);

  /**
   * @param id internal id
   * @param externalId external id of entity
   * @param siteId internal id of internal site
   * @param productId internal id of internal product
   * @param categoryIds
   * @param type type of sellout alias cause for sellout // using enumeration instead of string type, maybe change to string if required
   * @param availableSupply available stock in internal site (responds to Supply.availableSupply)
   * @param amount specifies the stock amount of inventory in overstock/dead stock/expiration, it is filled only for specific subset of
   *        sellout type (e.g. dead stock or (promo) overstock).
   * @param supplyLastInDays defines how many days will last supply todo verify with logio for which type of sellout is considered
   * @param delistedFrom corresponds to {@link ProductSiteBinding.validTo}, should be always set for delist and remodelling sellout type.
   *        It is the last day a product is being sold regularly for delists and the last day a site is opened for remodelling.
   * @param selloutDetected a date the sellout of this item was first detected (imported from external system)
   * @param lastPurchase date of last purchase/redistribution, null means there was none. Information about last purchase can be used to
   *        determine when a product expire.
   * @param promo flag indicating whether for a) over stock: there was promotion on product/site x days before sellout, b) exit process:
   *        helps to determine regular and in/out delist (if true, it is in/out, otherwise regular delist).
   * @param promotionId internal id of promotion, filled if promo flag is set to true. It is id of promotion with the highest priority.
   * @param stateFlags flags (should be used for import only)
   * @param processed defines whether an instance was processed (should be used for import only)
   * @param endReasonExternalId external id of a message specifying the reason why the sellout ended
   */
  function SelloutSupply(id, externalId, siteId, productId, categoryIds, type, availableSupply, amount, supplyLastInDays, delistedFrom, selloutDetected, lastPurchase, promo, promotionId, stateFlags, processed, endReasonExternalId) {
    var _this;

    _classCallCheck(this, SelloutSupply);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutSupply).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.siteId = siteId;
    _this.productId = productId;
    _this.categoryIds = categoryIds;
    _this.type = type;
    _this.availableSupply = availableSupply;
    _this.amount = amount;
    _this.supplyLastInDays = supplyLastInDays;
    _this.delistedFrom = delistedFrom;
    _this.selloutDetected = selloutDetected;
    _this.lastPurchase = lastPurchase;
    _this.promo = promo;
    _this.promotionId = promotionId;
    _this.stateFlags = stateFlags;
    _this.processed = processed;
    _this.endReasonExternalId = endReasonExternalId;
    return _this;
  }
  /**
   * @returns stock amount to be sold out on site with respect to sellout type (#amount field, or #availableSupply)
   */


  _createClass(SelloutSupply, [{
    key: "getStockAmount",
    value: function getStockAmount() {
      return this.amount !== null ? this.amount : this.availableSupply;
    }
    /**
     * Returns true if the core supply values differs.
     *
     * @param other sellout supply ti compare
     */

  }, {
    key: "supplyDiffers",
    value: function supplyDiffers(other) {
      return this.supplyLastInDays !== other.supplyLastInDays || !ValueWithUnit_1.isEqual(this.availableSupply, other.availableSupply) || !ValueWithUnit_1.isEqual(this.amount, other.amount);
    }
    /**
     * Converter from data-dictionary representation.
     */

  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutSupply(mat.id, mat.externalId, mat.siteId, mat.productId, mat.categoryIds, mat.type, mat.availableSupply, mat.amount, mat.supplyLastInDays, mat.delistedFrom, mat.selloutDetected, mat.lastPurchase, mat.promo, mat.promotionId, mat.stateFlags, mat.processed, mat.endReasonExternalId);
    }
  }]);

  return SelloutSupply;
}(StateDomainObject_1.StateDomainObject);

exports.SelloutSupply = SelloutSupply;
SelloutSupply.TYPES_WITH_NOT_NULL_AMOUNT = immutable_1.Set.of(SelloutType_1.SelloutType.DeadStock, SelloutType_1.SelloutType.Expiry, SelloutType_1.SelloutType.Overstock, SelloutType_1.SelloutType.OverstockPromo);
/**
 * Entity structure description
 */

SelloutSupply.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutSupply.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    siteId: builder.id('siteId'),
    productId: builder.id('productId'),
    categoryIds: builder.listOf(builder.id('categoryIds')),
    type: builder.senum('type', SelloutType_1.SelloutType, CodebookLookupSequence_1.CodebookLookupSequence.SelloutType),
    availableSupply: builder.data('availableSupply', {
      value: builder.bigNum('value'),
      unitId: builder.str('unitId')
    }),
    amount: builder.opt(builder.data('amount', {
      value: builder.bigNum('value'),
      unitId: builder.str('unitId')
    })),
    supplyLastInDays: builder.opt(builder.num('supplyLastInDays')),
    delistedFrom: builder.opt(builder.date('delistedFrom', DateParser_1.DateParser.ISO_PATTERN)),
    selloutDetected: builder.date('selloutDetected', DateParser_1.DateParser.ISO_PATTERN),
    lastPurchase: builder.opt(builder.date('lastPurchase', DateParser_1.DateParser.ISO_PATTERN)),
    promo: builder.opt(builder.bool('promo')),
    promotionId: builder.opt(builder.id('promotionId')),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag),
    processed: builder.bool('processed'),
    endReasonExternalId: builder.opt(builder.num('endReasonExternalId'))
  };
}();